import { useState } from "react";

const useNCBTimeline = () => {
  const [selectedPeriod, setSelectedPeriod] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  // Historical timeline data based on the provided content
  const timelineData = [
    {
      year: 1914,
      title: "Kongres Polisi Reserse Internasional Pertama",
      description:
        "Kongres Polisi Reserse Internasional ke-1 diadakan di Monaco dari tanggal 14 s.d. 18 April 1914 dihadiri beberapa ahli hukum dan perwira Polisi dari 14 negara Eropa, yang membahas kemungkinan pengembangan International Crime Records Office dan menyederhanakan prosedur Ekstradisi. Pecahnya perang dunia pertama telah menghambat perkembangan organisasi tersebut.",
      category: "founding",
      significance: "high",
      location: "Monaco",
    },
    {
      year: 1923,
      title: "Pembentukan ICPC",
      description:
        "Kongres Polisi Reserse Internasional ke-2 diadakan di Wina, Austria, menyepakati pembentukan ICPC yang berkedudukan di Wina, termasuk anggaran dasarnya. Presiden ICPC adalah Kepala Kepolisian Wina, Austria, Dr Johannes Schober, yang juga sebagai inisiator pembentukan organisasi tersebut. ICPC masih beranggotakan negara-negara Eropa.",
      category: "founding",
      significance: "high",
      location: "Wina, Austria",
    },
    {
      year: 1926,
      title: "Konsep National Central Bureau",
      description:
        "Sidang Umum ICPC di Berlin, menyarankan kepada setiap negara anggota agar membentuk National Central Bureau (NCB) sebagai pusat penghubung di dalam struktur organisasi kepolisian.",
      category: "development",
      significance: "high",
      location: "Berlin",
    },
    {
      year: 1927,
      title: "Resolusi Pembentukan NCB",
      description:
        "Sidang Umum ICPC telah menghasilkan resolusi untuk membentuk NCB di setiap negara anggota.",
      category: "development",
      significance: "medium",
      location: "International",
    },
    {
      year: 1930,
      title: "Departemen Khusus Data Kejahatan",
      description:
        "Pembentukan departemen khusus untuk mengelola data tentang pemalsuan uang, catatan kejahatan dan pemalsuan paspor dengan tujuan untuk pertukaran informasi antar negara anggota.",
      category: "technology",
      significance: "medium",
      location: "International",
    },
    {
      year: 1932,
      title: "Jabatan Sekretaris Jenderal",
      description:
        "Setelah kematian Dr Schober, dibentuk suatu jabatan baru yang diberi nama Sekretaris Jenderal ICPC. Sekjen yang pertama adalah Kepala Kepolisian Austria, Mr. Oskar Dressler.",
      category: "leadership",
      significance: "medium",
      location: "Austria",
    },
    {
      year: 1935,
      title: "Jaringan Radio Komunikasi",
      description:
        "Jaringan radio komunikasi Internasional INTERPOL diluncurkan.",
      category: "technology",
      significance: "medium",
      location: "International",
    },
    {
      year: 1938,
      title: "Kendali Nazi",
      description:
        "Nazi mengambil kendali setelah memecat Presiden Michael Sjubl mengakibatkan banyak negara anggota tidak aktif dalam kegiatan organisasi tersebut.",
      category: "crisis",
      significance: "high",
      location: "International",
    },
    {
      year: 1942,
      title: "Markas Pindah ke Berlin",
      description:
        "ICPC berada dibawah kendali Jerman dan markas besarnya dipindahkan ke Berlin.",
      category: "crisis",
      significance: "high",
      location: "Berlin",
    },
    {
      year: 1946,
      title: "Kebangkitan Pasca Perang",
      description:
        "Setelah Perang Dunia ke II, diselenggarakan konferensi ICPC di Brussels untuk menghidupkan kembali kegiatan organisasi tersebut, dengan pengesahan Anggaran Dasar yang baru. Markas Besar ICPC dipindahkan ke Paris dan kata INTERPOL dipilih sebagai alamat telegrafis.",
      category: "reconstruction",
      significance: "high",
      location: "Brussels/Paris",
    },
    {
      year: 1949,
      title: "Pengakuan PBB",
      description:
        "PBB mengakui ICPC-INTERPOL sebagai organisasi non-pemerintah.",
      category: "recognition",
      significance: "high",
      location: "International",
    },
    {
      year: 1956,
      title: "Nama Resmi ICPO-INTERPOL",
      description:
        "ICPC menjadi International Criminal Police Organization INTERPOL disingkat ICPO-INTERPOL.",
      category: "development",
      significance: "high",
      location: "International",
    },
    {
      year: 1958,
      title: "Regulasi Keuangan",
      description:
        "Ketentuan regulasi keuangan disahkan dan iuran kontribusi negara anggota direvisi.",
      category: "administration",
      significance: "low",
      location: "International",
    },
    {
      year: 1963,
      title: "Konferensi Regional Pertama",
      description: "Konferensi Regional pertama diadakan di Monrovia, Liberia.",
      category: "expansion",
      significance: "medium",
      location: "Monrovia, Liberia",
    },
    {
      year: 1965,
      title: "Kebijakan Operasi NCB",
      description:
        "Sidang Umum menetapkan kebijakan tentang operasi dan tanggung jawab NCB.",
      category: "policy",
      significance: "medium",
      location: "International",
    },
    {
      year: 1966,
      title: "Pindah ke Saint Cloud",
      description:
        "Markas Besar Sekretariat Jenderal ICPO-INTERPOL dipindahkan ke Saint Cloud di luar Paris.",
      category: "administration",
      significance: "low",
      location: "Saint Cloud, Perancis",
    },
    {
      year: 1971,
      title: "Organisasi Inter-Pemerintahan",
      description:
        "PBB mengakui ICPO-INTERPOL sebagai organisasi inter-pemerintahan.",
      category: "recognition",
      significance: "high",
      location: "International",
    },
    {
      year: 1972,
      title: "Kesepakatan dengan Perancis",
      description:
        "Kesepakatan antara Markas Besar ICPO-INTERPOL dengan Pemerintah Perancis tentang pengukuhan ICPO-INTERPOL sebagai organisasi internasional.",
      category: "recognition",
      significance: "medium",
      location: "Perancis",
    },
    {
      year: 1973,
      title: "Hari Ulang Tahun ke-50",
      description: "Organisasi merayakan hari ulang tahun ke-50 di Wina.",
      category: "milestone",
      significance: "medium",
      location: "Wina",
    },
    {
      year: 1982,
      title: "Badan Pengawas Data",
      description:
        "Dibentuk badan independen untuk memantau pelaksanaan ketentuan INTERPOL dalam memproteksi data yang selanjutnya pada tahun 2003 berubah menjadi Komisi pengendalian file INTERPOL.",
      category: "governance",
      significance: "medium",
      location: "International",
    },
    {
      year: 1989,
      title: "Pindah ke Lyon",
      description:
        "Pada tanggal 27 November 1989 Markas Besar ICPO-INTERPOL pindah ke Lyon.",
      category: "administration",
      significance: "high",
      location: "Lyon, Perancis",
    },
    {
      year: 1990,
      title: "Sistem X-400",
      description:
        "Peluncuran sistem komunikasi INTERPOL X-400 digunakan oleh seluruh NCB untuk mengirimkan pesan elektronik ke NCB negara lain dan Sekretariat Jenderal.",
      category: "technology",
      significance: "high",
      location: "International",
    },
    {
      year: 1992,
      title: "169 Negara Anggota",
      description:
        "Anggota ICPO-INTERPOL berjumlah 169 negara. Penambahan fasilitas automatic search (ASF) dalam database INTERPOL.",
      category: "expansion",
      significance: "medium",
      location: "International",
    },
    {
      year: 1994,
      title: "176 Negara Anggota",
      description: "Jumlah anggota ICPO-INTERPOL bertambah 176 negara.",
      category: "expansion",
      significance: "low",
      location: "International",
    },
    {
      year: 1995,
      title: "Sub-Biro Regional",
      description:
        "Sidang Umum mengesahkan pedoman pembentukan dan pengoperasian beberapa Sub-Biro Regional.",
      category: "expansion",
      significance: "medium",
      location: "International",
    },
    {
      year: 1998,
      title: "Database ICIS",
      description:
        "Pembangunan database INTERPOL Criminal Information System (ICIS).",
      category: "technology",
      significance: "high",
      location: "International",
    },
    {
      year: 2002,
      title: "Sistem I-24/7",
      description:
        "Peluncuran sistem komunikasi global kepolisian (IGCS) I-24/7 menggantikan X-400. Kanada merupakan negara pertama yang terkoneksi dengan sistem tersebut.",
      category: "technology",
      significance: "high",
      location: "International",
    },
    {
      year: 2003,
      title: "Command and Coordination Centre",
      description:
        "Peresmian Pusat Komando dan Koordinasi (Command and Coordination Centre) di Sekretariat Jenderal, yang beroperasi 24 jam per hari, 7 hari dalam seminggu.",
      category: "operations",
      significance: "high",
      location: "Lyon, Perancis",
    },
    {
      year: 2004,
      title: "Perwakilan di PBB",
      description:
        "Penempatan Perwakilan Khusus INTERPOL di Markas PBB New York.",
      category: "diplomacy",
      significance: "medium",
      location: "New York",
    },
    {
      year: 2005,
      title: "Special Notice & MIND/FIND",
      description:
        "Penerbitan Special Notice oleh ICPO-INTERPOL atas permintaan Dewan Keamanan PBB terhadap individu dan kelompok Al Qaeda dan Taliban dan afiliasinya. Peluncuran MIND/FIND (Mobile INTERPOL Network Database/Fix INTERPOL Network Database) sebagai fasilitas bagi penegak hukum di lapangan untuk pengecekan validitas paspor dan kendaraan bermotor.",
      category: "technology",
      significance: "high",
      location: "International",
    },
    {
      year: 2008,
      title: "Perwakilan di Uni Eropa",
      description:
        "Penempatan perwakilan khusus ICPO-INTERPOL di kantor pusat Uni Eropa di Brussels.",
      category: "diplomacy",
      significance: "medium",
      location: "Brussels",
    },
    {
      year: 2011,
      title: "190 Negara Anggota",
      description:
        "Jumlah anggota ICPO-INTERPOL menjadi 190 negara dengan masuknya Sudan Selatan, Curacao dan St Marteen.",
      category: "expansion",
      significance: "medium",
      location: "International",
    },
  ];

  // NCB Indonesia specific data
  const ncbIndonesiaData = {
    definition:
      "Sekretariat NCB-INTERPOL Indonesia adalah salah satu Biro yang berada dalam struktur organisasi Divisi Hubungan Internasional Polri (Divhubinter Polri) yang bertugas membina, mengawasi dan mengendalikan penyelengaraan tugas NCB-INTERPOL dalam kerja sama internasional dalam lingkup bilateral dan multilateral.",
    functions: [
      "pelaksanaan kerja sama internasional dalam rangka penanggulangan kejahatan internasional/transnasional",
      "penyusunan perjanjian internasional dan menyelenggarakan forum pertemuan internasional, bilateral dan multilateral",
      "pertukaran informasi intelijen kriminal melalui sistem jaringan INTERPOL dan ASEANAPOL",
      "pembinaan teknis Atase Polri, SLO, STP, dan LO",
    ],
    departments: [
      {
        name: "Bagian Kejahatan Internasional (Bagjatinter)",
        oldName:
          "Bagian Kejahatan Transnasional dan Internasional (Bagjatranin)",
        description:
          "Bertugas melaksanakan kegiatan kerja sama antar anggota NCB-INTERPOL dalam rangka pencegahan dan pemberantasan kejahatan Internasional/transnasional serta pelayanan umum internasional dalam kaitannya dengan kejahatan termasuk pelaku, buronan dan bantuan hukum internasional.",
        subDepartments: [
          "Subbagjatum",
          "Subbagjateksus",
          "Subbagprodukinter",
          "Subbagbankuminter",
        ],
      },
      {
        name: "Bagian Komunikasi Internasional (Bagkominter)",
        description:
          "Melaksanakan kerja sama internasional dalam penyelenggaraan dan pengembangan sistem pertukaran informasi dalam upaya pencegahan dan pemberantasan kejahatan internasional/transnasional melalui sarana sistem jaringan INTERPOL dan ASEANAPOL.",
        subDepartments: ["Subbagtekkom", "Subbaginfodata", "Subbagpubdok"],
      },
      {
        name: "Bagian Konvensi Internasional (Bagkonvinter)",
        oldName: "Bagian Perbatasan Internasional (Bagbatanas)",
        description:
          "Mempersiapkan pelaksanaan perjanjian Internasional dan penyelenggaraan pertemuan internasional baik dilaksanakan di dalam maupun di luar negeri dalam rangka penanggulangan kejahatan Internasional/transnasional dan pembangunan kapasitas.",
        subDepartments: [
          "Subbag Amerop",
          "Subbag Aspasaf",
          "Subbag Organisasi Internasional (OI)",
          "Subbag Perjanjian Internasional (PI)",
        ],
      },
      {
        name: "Bagian Liaison Officer dan Perbatasan (Baglotas)",
        description:
          "Melaksanakan pembinaan teknis Atase Polri, SLO, Staf Teknis Polri dan LO di luar negeri termasuk sumber daya manusia Polri dan sarana prasarana tugas Polri di perbatasan.",
        subDepartments: ["Subbag LO", "Subbagbatas"],
      },
    ],
  };

  // Categories for filtering
  const categories = [
    { key: "all", label: "Semua Periode", color: "primary" },
    { key: "founding", label: "Pembentukan", color: "success" },
    { key: "development", label: "Pengembangan", color: "info" },
    { key: "technology", label: "Teknologi", color: "warning" },
    { key: "crisis", label: "Krisis", color: "error" },
    { key: "reconstruction", label: "Rekonstruksi", color: "success" },
    { key: "recognition", label: "Pengakuan", color: "primary" },
    { key: "expansion", label: "Ekspansi", color: "secondary" },
    { key: "operations", label: "Operasional", color: "accent" },
    { key: "diplomacy", label: "Diplomasi", color: "info" },
  ];

  // Filter timeline data
  const filteredTimeline = timelineData.filter((item) => {
    const matchesPeriod =
      selectedPeriod === "all" || item.category === selectedPeriod;
    const matchesSearch =
      searchQuery === "" ||
      item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.location.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesPeriod && matchesSearch;
  });

  // Get category info
  const getCategoryInfo = (categoryKey) => {
    return categories.find((cat) => cat.key === categoryKey) || categories[0];
  };

  return {
    // State
    selectedPeriod,
    searchQuery,

    // Data
    timelineData: filteredTimeline,
    ncbIndonesiaData,
    categories,

    // Actions
    setSelectedPeriod,
    setSearchQuery,
    getCategoryInfo,
  };
};

export default useNCBTimeline;
